module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei1.svg";